﻿/*!
    *
    * Wijmo Library 5.20251.34
    * https://developer.mescius.com/wijmo
    *
    * Copyright(c) MESCIUS inc. All rights reserved.
    *
    * Licensed under the End-User License Agreement For MESCIUS Wijmo Software.
    * us.sales@mescius.com
    * https://developer.mescius.com/wijmo/licensing
    *
    */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { VueApi, WjComponentBehavior } from '@mescius/wijmo.vue2.base';
import * as wjcChartAnalytics from '@mescius/wijmo.chart.analytics';
var WjFlexChartTrendLineBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartTrendLineBehavior, _super);
    function WjFlexChartTrendLineBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartTrendLineBehavior.tag = 'wj-flex-chart-trend-line';
    WjFlexChartTrendLineBehavior.parentProp = 'series';
    WjFlexChartTrendLineBehavior.siblingId = 'series';
    WjFlexChartTrendLineBehavior.props = [
        'wjProperty',
        'axisX',
        'axisY',
        'binding',
        'bindingX',
        'cssClass',
        'name',
        'altStyle',
        'symbolMarker',
        'symbolSize',
        'symbolStyle',
        'visibility',
        'itemsSource',
        'interpolateNulls',
        'tooltipContent',
        'itemFormatter',
        'sampleCount',
        'order',
        'fitType',
        'minX',
        'maxX',
    ];
    WjFlexChartTrendLineBehavior.events = [
        'initialized',
        'rendering',
        'rendered'
    ];
    WjFlexChartTrendLineBehavior.changeEvents = {
        'chart.seriesVisibilityChanged': ['visibility'],
    };
    WjFlexChartTrendLineBehavior.classCtor = function () { return wjcChartAnalytics.TrendLine; };
    return WjFlexChartTrendLineBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.analytics.TrendLine} class.
 *
 * The <b>wj-flex-chart-trend-line</b> component should be contained in
 * one of the following components:
 * {@link wijmo.vue2.chart.WjFlexChart}
 *  or {@link wijmo.vue2.chart.finance.WjFinancialChart}.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.analytics.TrendLine} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartTrendLine = WjFlexChartTrendLineBehavior.register();
function registerV3WjFlexChartTrendLine(app) {
    app.component(WjFlexChartTrendLineBehavior.tag, WjFlexChartTrendLine);
}
var WjFlexChartMovingAverageBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartMovingAverageBehavior, _super);
    function WjFlexChartMovingAverageBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartMovingAverageBehavior.tag = 'wj-flex-chart-moving-average';
    WjFlexChartMovingAverageBehavior.parentProp = 'series';
    WjFlexChartMovingAverageBehavior.siblingId = 'series';
    WjFlexChartMovingAverageBehavior.props = [
        'wjProperty',
        'axisX',
        'axisY',
        'binding',
        'bindingX',
        'cssClass',
        'name',
        'altStyle',
        'symbolMarker',
        'symbolSize',
        'symbolStyle',
        'visibility',
        'itemsSource',
        'interpolateNulls',
        'tooltipContent',
        'itemFormatter',
        'sampleCount',
        'period',
        'type'
    ];
    WjFlexChartMovingAverageBehavior.events = [
        'initialized',
        'rendering',
        'rendered'
    ];
    WjFlexChartMovingAverageBehavior.changeEvents = {
        'chart.seriesVisibilityChanged': ['visibility'],
    };
    WjFlexChartMovingAverageBehavior.classCtor = function () { return wjcChartAnalytics.MovingAverage; };
    return WjFlexChartMovingAverageBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.analytics.MovingAverage} class.
 *
 * The <b>wj-flex-chart-moving-average</b> component should be contained in
 * one of the following components:
 * {@link wijmo.vue2.chart.WjFlexChart}
 *  or {@link wijmo.vue2.chart.finance.WjFinancialChart}.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.analytics.MovingAverage} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartMovingAverage = WjFlexChartMovingAverageBehavior.register();
function registerV3WjFlexChartMovingAverage(app) {
    app.component(WjFlexChartMovingAverageBehavior.tag, WjFlexChartMovingAverage);
}
var WjFlexChartYFunctionSeriesBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartYFunctionSeriesBehavior, _super);
    function WjFlexChartYFunctionSeriesBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartYFunctionSeriesBehavior.tag = 'wj-flex-chart-y-function-series';
    WjFlexChartYFunctionSeriesBehavior.parentProp = 'series';
    WjFlexChartYFunctionSeriesBehavior.siblingId = 'series';
    WjFlexChartYFunctionSeriesBehavior.props = [
        'wjProperty',
        'axisX',
        'axisY',
        'binding',
        'bindingX',
        'cssClass',
        'name',
        'altStyle',
        'symbolMarker',
        'symbolSize',
        'symbolStyle',
        'visibility',
        'itemsSource',
        'interpolateNulls',
        'tooltipContent',
        'itemFormatter',
        'sampleCount',
        'min',
        'max',
        'func'
    ];
    WjFlexChartYFunctionSeriesBehavior.events = [
        'initialized',
        'rendering',
        'rendered'
    ];
    WjFlexChartYFunctionSeriesBehavior.changeEvents = {
        'chart.seriesVisibilityChanged': ['visibility'],
    };
    WjFlexChartYFunctionSeriesBehavior.classCtor = function () { return wjcChartAnalytics.YFunctionSeries; };
    return WjFlexChartYFunctionSeriesBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.analytics.YFunctionSeries} class.
 *
 * The <b>wj-flex-chart-y-function-series</b> component should be contained in
 * one of the following components:
 * {@link wijmo.vue2.chart.WjFlexChart}
 *  or {@link wijmo.vue2.chart.finance.WjFinancialChart}.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.analytics.YFunctionSeries} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartYFunctionSeries = WjFlexChartYFunctionSeriesBehavior.register();
function registerV3WjFlexChartYFunctionSeries(app) {
    app.component(WjFlexChartYFunctionSeriesBehavior.tag, WjFlexChartYFunctionSeries);
}
var WjFlexChartParametricFunctionSeriesBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartParametricFunctionSeriesBehavior, _super);
    function WjFlexChartParametricFunctionSeriesBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartParametricFunctionSeriesBehavior.tag = 'wj-flex-chart-parametric-function-series';
    WjFlexChartParametricFunctionSeriesBehavior.parentProp = 'series';
    WjFlexChartParametricFunctionSeriesBehavior.siblingId = 'series';
    WjFlexChartParametricFunctionSeriesBehavior.props = [
        'wjProperty',
        'axisX',
        'axisY',
        'binding',
        'bindingX',
        'cssClass',
        'name',
        'altStyle',
        'symbolMarker',
        'symbolSize',
        'symbolStyle',
        'visibility',
        'itemsSource',
        'interpolateNulls',
        'tooltipContent',
        'itemFormatter',
        'sampleCount',
        'min',
        'max',
        'func',
        'xFunc',
        'yFunc'
    ];
    WjFlexChartParametricFunctionSeriesBehavior.events = [
        'initialized',
        'rendering',
        'rendered'
    ];
    WjFlexChartParametricFunctionSeriesBehavior.changeEvents = {
        'chart.seriesVisibilityChanged': ['visibility'],
    };
    WjFlexChartParametricFunctionSeriesBehavior.classCtor = function () { return wjcChartAnalytics.ParametricFunctionSeries; };
    return WjFlexChartParametricFunctionSeriesBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.analytics.ParametricFunctionSeries} class.
 *
 * The <b>wj-flex-chart-parametric-function-series</b> component should be contained in
 * one of the following components:
 * {@link wijmo.vue2.chart.WjFlexChart}
 *  or {@link wijmo.vue2.chart.finance.WjFinancialChart}.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.analytics.ParametricFunctionSeries} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartParametricFunctionSeries = WjFlexChartParametricFunctionSeriesBehavior.register();
function registerV3WjFlexChartParametricFunctionSeries(app) {
    app.component(WjFlexChartParametricFunctionSeriesBehavior.tag, WjFlexChartParametricFunctionSeries);
}
var WjFlexChartWaterfallBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartWaterfallBehavior, _super);
    function WjFlexChartWaterfallBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartWaterfallBehavior.tag = 'wj-flex-chart-waterfall';
    WjFlexChartWaterfallBehavior.parentProp = 'series';
    WjFlexChartWaterfallBehavior.siblingId = 'series';
    WjFlexChartWaterfallBehavior.props = [
        'wjProperty',
        'axisX',
        'axisY',
        'binding',
        'bindingX',
        'cssClass',
        'name',
        'altStyle',
        'symbolMarker',
        'symbolSize',
        'symbolStyle',
        'visibility',
        'itemsSource',
        'interpolateNulls',
        'tooltipContent',
        'itemFormatter',
        'relativeData',
        'start',
        'startLabel',
        'showTotal',
        'totalLabel',
        'showIntermediateTotal',
        'intermediateTotalPositions',
        'intermediateTotalLabels',
        'connectorLines',
        'styles'
    ];
    WjFlexChartWaterfallBehavior.events = [
        'initialized',
        'rendering',
        'rendered'
    ];
    WjFlexChartWaterfallBehavior.changeEvents = {
        'chart.seriesVisibilityChanged': ['visibility'],
    };
    WjFlexChartWaterfallBehavior.classCtor = function () { return wjcChartAnalytics.Waterfall; };
    return WjFlexChartWaterfallBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.analytics.Waterfall} class.
 *
 * The <b>wj-flex-chart-waterfall</b> component should be contained in
 * one of the following components:
 * {@link wijmo.vue2.chart.WjFlexChart}
 *  or {@link wijmo.vue2.chart.finance.WjFinancialChart}.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.analytics.Waterfall} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartWaterfall = WjFlexChartWaterfallBehavior.register();
function registerV3WjFlexChartWaterfall(app) {
    app.component(WjFlexChartWaterfallBehavior.tag, WjFlexChartWaterfall);
}
var WjFlexChartBoxWhiskerBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartBoxWhiskerBehavior, _super);
    function WjFlexChartBoxWhiskerBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartBoxWhiskerBehavior.tag = 'wj-flex-chart-box-whisker';
    WjFlexChartBoxWhiskerBehavior.parentProp = 'series';
    WjFlexChartBoxWhiskerBehavior.siblingId = 'series';
    WjFlexChartBoxWhiskerBehavior.props = [
        'wjProperty',
        'axisX',
        'axisY',
        'binding',
        'bindingX',
        'cssClass',
        'name',
        'altStyle',
        'symbolMarker',
        'symbolSize',
        'symbolStyle',
        'visibility',
        'itemsSource',
        'interpolateNulls',
        'tooltipContent',
        'itemFormatter',
        'quartileCalculation',
        'groupWidth',
        'gapWidth',
        'showMeanLine',
        'meanLineStyle',
        'showMeanMarker',
        'meanMarkerStyle',
        'showInnerPoints',
        'showOutliers'
    ];
    WjFlexChartBoxWhiskerBehavior.events = [
        'initialized',
        'rendering',
        'rendered'
    ];
    WjFlexChartBoxWhiskerBehavior.changeEvents = {
        'chart.seriesVisibilityChanged': ['visibility'],
    };
    WjFlexChartBoxWhiskerBehavior.classCtor = function () { return wjcChartAnalytics.BoxWhisker; };
    return WjFlexChartBoxWhiskerBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.analytics.BoxWhisker} class.
 *
 * The <b>wj-flex-chart-box-whisker</b> component should be contained in
 * one of the following components:
 * {@link wijmo.vue2.chart.WjFlexChart}
 *  or {@link wijmo.vue2.chart.finance.WjFinancialChart}.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.analytics.BoxWhisker} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartBoxWhisker = WjFlexChartBoxWhiskerBehavior.register();
function registerV3WjFlexChartBoxWhisker(app) {
    app.component(WjFlexChartBoxWhiskerBehavior.tag, WjFlexChartBoxWhisker);
}
var WjFlexChartErrorBarBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartErrorBarBehavior, _super);
    function WjFlexChartErrorBarBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartErrorBarBehavior.tag = 'wj-flex-chart-error-bar';
    WjFlexChartErrorBarBehavior.parentProp = 'series';
    WjFlexChartErrorBarBehavior.siblingId = 'series';
    WjFlexChartErrorBarBehavior.props = [
        'wjProperty',
        'axisX',
        'axisY',
        'binding',
        'bindingX',
        'cssClass',
        'name',
        'altStyle',
        'symbolMarker',
        'symbolSize',
        'symbolStyle',
        'visibility',
        'itemsSource',
        'interpolateNulls',
        'tooltipContent',
        'itemFormatter',
        'chartType',
        'errorBarStyle',
        'value',
        'errorAmount',
        'endStyle',
        'direction'
    ];
    WjFlexChartErrorBarBehavior.events = [
        'initialized',
        'rendering',
        'rendered'
    ];
    WjFlexChartErrorBarBehavior.changeEvents = {
        'chart.seriesVisibilityChanged': ['visibility'],
    };
    WjFlexChartErrorBarBehavior.classCtor = function () { return wjcChartAnalytics.ErrorBar; };
    return WjFlexChartErrorBarBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.analytics.ErrorBar} class.
 *
 * The <b>wj-flex-chart-error-bar</b> component should be contained in
 * a {@link wijmo.vue2.chart.WjFlexChart} component.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.analytics.ErrorBar} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartErrorBar = WjFlexChartErrorBarBehavior.register();
function registerV3WjFlexChartErrorBar(app) {
    app.component(WjFlexChartErrorBarBehavior.tag, WjFlexChartErrorBar);
}
var WjFlexChartBreakEvenBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartBreakEvenBehavior, _super);
    function WjFlexChartBreakEvenBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartBreakEvenBehavior.tag = 'wj-flex-chart-break-even';
    WjFlexChartBreakEvenBehavior.parentProp = 'series';
    WjFlexChartBreakEvenBehavior.siblingId = 'series';
    WjFlexChartBreakEvenBehavior.props = [
        'wjProperty',
        'axisX',
        'axisY',
        'binding',
        'bindingX',
        'cssClass',
        'name',
        'altStyle',
        'symbolMarker',
        'symbolSize',
        'symbolStyle',
        'visibility',
        'itemsSource',
        'interpolateNulls',
        'tooltipContent',
        'itemFormatter',
        'fixedCost',
        'variableCost',
        'salesPrice',
        'styles'
    ];
    WjFlexChartBreakEvenBehavior.events = [
        'initialized',
        'rendering',
        'rendered'
    ];
    WjFlexChartBreakEvenBehavior.changeEvents = {
        'chart.seriesVisibilityChanged': ['visibility'],
    };
    WjFlexChartBreakEvenBehavior.classCtor = function () { return wjcChartAnalytics.BreakEven; };
    return WjFlexChartBreakEvenBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.analytics.BreakEven} class.
 *
 * The <b>wj-flex-chart-break-even</b> component should be contained in
 * a {@link wijmo.vue2.chart.WjFlexChart} component.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.analytics.BreakEven} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartBreakEven = WjFlexChartBreakEvenBehavior.register();
function registerV3WjFlexChartBreakEven(app) {
    app.component(WjFlexChartBreakEvenBehavior.tag, WjFlexChartBreakEven);
}
export function registerChartAnalytics(app) {
    if (VueApi.isV3Plus) {
        registerV3WjFlexChartTrendLine(app);
        registerV3WjFlexChartMovingAverage(app);
        registerV3WjFlexChartYFunctionSeries(app);
        registerV3WjFlexChartParametricFunctionSeries(app);
        registerV3WjFlexChartWaterfall(app);
        registerV3WjFlexChartBoxWhisker(app);
        registerV3WjFlexChartErrorBar(app);
        registerV3WjFlexChartBreakEven(app);
    }
}
